<template>
<div class="chapter">
<div class="inner_page">
<div id="eve-of-warfare-1.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="body-center"><img alt="eve-of-warfare.ai" class="" src="images/eve-of-warfare-tp.jpg" width="98%"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eveofwarfaretp.vue?a9fadeda